export default "__VITE_ASSET__D36d$UBp__"